// extracted by mini-css-extract-plugin
export default {"ingress":"Ingress_ingress__gvK1A"};